import { useLanguage } from "../contexts/LanguageContext"

export default function Footer() {
  const { t } = useLanguage()

  return (
    <footer className="bg-gray-900 text-white py-12 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Logo & Description */}
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="/makkok_transparent.png"
                alt="Makkok Logo"
                className="h-10 w-auto"
              />
              <span className="text-2xl font-bold text-[#FF8500]">MAKKOK</span>
            </div>
            <p className="text-gray-400 mb-6">{t("footer.description")}</p>
          </div>

          {/* Quick Links */}
          <div className="flex-1 md:text-right">
            <h3 className="text-lg font-semibold mb-4">{t("footer.quickLinks")}</h3>
            <div className="space-y-2">
              <a
                href="/terms-of-use"
                className="block text-gray-400 hover:text-white transition-colors"
              >
                {t("footer.termsOfUse")}
              </a>
              <a
                href="/privacy-policy"
                className="block text-gray-400 hover:text-white transition-colors"
              >
                {t("footer.privacyPolicy")}
              </a>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
             {t("footer.copyright")} © 2025 {t("hero.mainHeadding.title3")}. {t("footer.allRightsReserved")}
          </p>
        </div>
      </div>
    </footer>
  )
}
